<template>
  <div class="vehicle-detail pa-10 pt-0" v-if="vehicle">

    <tab-navigation
        :title="$tc('vehicle.vehicle')"
        icon="mdi-car"
        :breadcrumbs="breadcrumbs"
    >
      <v-tabs>
        <v-tab :to="{name: 'vehicle.detail'}" exact>{{ $t('information') }}</v-tab>
        <v-tab :to="{name: 'vehicle.usages'}">{{ $t('charging-point.usage') }}</v-tab>
        <v-tab v-if="currentUser.isZE" :to="{name: 'vehicle.readings'}">{{ $t('vehicle.readings') }}</v-tab>
        <v-tab :to="{name: 'vehicle.assignments'}">{{ $t('vehicle.assignment-history') }}</v-tab>
        <v-tab v-if="vehicle.connectedVehicleAvailable || vehicle.connectedVehicleEnabled" :to="{name: 'vehicle.telematics'}">{{ $t('vehicle.connection') }}</v-tab>
        <v-tab v-if="currentUser.permissions.includes('OPERATOR_WRITE')" :to="{name: 'vehicle.licences'}">{{ $tc('subscription.licence', 2) }}</v-tab>
      </v-tabs>
    </tab-navigation>

    <v-divider class="mb-6" />

    <router-view></router-view>

  </div>
</template>

<script>
import VehicleRepository from "@repository/VehicleRepository";
import TabNavigation from "@blocks/TabNavigation.vue";
import Tools from "@includes/tools";

export default {
  name: 'VehicleDetail',
  components: { TabNavigation },

  data() {
    return {
      vehicle: null,
    }
  },

  mounted() {
    if (!this.currentUser.permissions.includes('VEHICLE_READ')) {
      this.$router.replace({ name: 'dashboard' })
      return
    }
    this.loadData()
  },

  watch: {
    id() {
      this.loadData()
    },
  },

  computed: {
    id() {
      return this.$route.params.id
    },

    vehicleLabel() {
      if (this.vehicle?.name) return this.vehicle.name
      if (this.vehicle?.registrationNumber) return this.vehicle.registrationNumber
      return this.vehicle?.id || ''
    },

    breadcrumbs() {
      let items = []

      if (this.vehicle?.organization) {
        items.push({
          text: this.$tc('vehicle.vehicle', 2),
          to: { name: 'vehicles.search' },
          exact: true,
        })
        items.push({
          text: this.vehicle.organization.name,
          to: { name: 'organizations.vehicles', params: { id: this.vehicle.organization.id } },
          exact: true,
        })
      } else if (this.vehicle?.customer) {
        items.push({
          text: this.$tc('customer.customer', 2),
          to: { name: 'customers' },
        })
        items.push({
          text: Tools.customerLabel(this.vehicle.customer),
          to: { name: 'customer.detail', params: { id: this.vehicle.customer.id } },
          exact: true,
        })
      }

      items.push({ text: this.vehicleLabel })

      return items
    },
  },

  methods: {
    loadData() {
      return new Promise((resolve, reject) => {
        if (this.id) {
          this.showLoading(true)
          VehicleRepository.hub(this.id).then(vehicle => {
            this.vehicle = vehicle
            this.showLoading(false)
            resolve(vehicle)
          }).catch(err => {
            this.notifyError(err)
            this.showLoading(false)
            reject(err)
          })
        }
      })
    },
  },
}
</script>

<style lang="scss">
</style>
